module.exports = __webpack_public_path__ + "img/lead01.81666173.png";